import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  supplierCount: null,
  userCount: null,
  lastUpdatedAt: null
};

const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    setSupplierCount: (state, action) => {
      state.supplierCount = action.payload;
      state.lastUpdatedAt = new Date().toISOString();
    },
    setUserCount: (state, action) => {
      state.userCount = action.payload;
      state.lastUpdatedAt = new Date().toISOString();
    },
    setCounts: (state, action) => {
      const { supplierCount, userCount } = action.payload || {};
      if (typeof supplierCount === 'number') {
        state.supplierCount = supplierCount;
      }
      if (typeof userCount === 'number') {
        state.userCount = userCount;
      }
      state.lastUpdatedAt = new Date().toISOString();
    },
    resetStats: () => initialState
  }
});

export const { setSupplierCount, setUserCount, setCounts, resetStats } = statsSlice.actions;
export default statsSlice.reducer;

